module.exports = __webpack_public_path__ + "img/icon_office.6d4e4da7.svg";